<div id='floating-button-result' fxLayout='column' fxLayoutAlign='start center'>
    <div class='content-block dx-card responsive-paddings ocl-top-container' style='width: 95vw'>
        <div fxLayout='row' fxLayoutAlign='stretch' class='padding-block'>
            <h3>Advanced Search - Laboratory Results</h3>
        </div>
    </div>
    <div class='content-block dx-card responsive-paddings ocl-bottom-container' style='width: 95vw !important;'>
        <app-advanced-search-content [filtersSubmitted]='formSubmitted'
                                     [showMissingInfo]='showMissingInfo'></app-advanced-search-content>
    </div>
</div>
